const n = "{{currentTime}} as {{duration}}", a = "Toradh cuardaigh {{current}} de {{total}}", t = "Níor aimsíodh aon toradh", s = "{{count}} (d)t(h)oradh aimsithe", o = "{{count}} toradh aimsithe", i = 'Ag seinm ó $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) agus $t(SECONDS, { "count": {{seconds}} }).', c = 'Ag seinm ó $t(MINUTES, { "count": {{minutes}} }) agus $t(SECONDS, { "count": {{seconds}} }).', h = 'Ag seinm ó $t(SECONDS, { "count": {{seconds}} }).', A = "Earráid ag sábháil athruithe ar an tras-scríbhinn.", T = "Líne trascríbhinne ag {{time}}. Tá an t-ábhar: {{text}}.", E = 'Coimeádán línte trascríbhinne. Ansin $t(TRANSCRIPT_LINES, { "count": {{count}} }) taobh istigh den choimeádán seo. Úsáid an eochair saighde chun nascleanúint a dhéanamh sa choimeádán seo.', S = "Ag sábháil athruithe...", e = "Athruithe sábháilte chuig an tras-scríbhinn.", r = "Tá an cnaipe nuashonraithe fotheidil ar fáil anois.", _ = "Gníomh", N = "Cuir nóta leis ag {{time}}", R = "Cuir ceist leis ag {{time}}", O = "Nótaí Mínithe", C = "Uath", I = "Uath ({{quality}})", d = "Ar ais", u = "Fotheidil", g = "Teanga na bhFotheideal", l = "Bainistigh Fotheidil", L = "Scrios {{language}}", P = "Clómhéid", U = "Teanga na bhFotheideal: {{language}}", D = "{{language}} (uathoibríoch)", m = "Glan an Chuardach", M = "Dún", b = "Ráitis", G = "Lean ar aghaidh", Y = "Laghdaigh Luas na hAthsheanma", F = "Laghdaigh Fuaim faoin méid seo: {{percent}}%", B = "Saighead Síos", H = "Dún an tEagarthóir Trascríbhinne", V = "Nuashonraigh Fotheidil", K = "Earráid!", f = "Ag sábháil...", W = "Sábháilte!", $ = "Cuir Tras-scríbhinn in Eagar", p = "Ní féidir téacs a bheith folamh!", Q = "Lánscáileán", J = "{{count}} uair an chloig", q = "{{count}} uair an chloig", x = "Méadaigh Luas na hAthsheanma", Z = "Méadaigh Fuaim faoin méid seo: {{percent}}%", z = "Inbhéartaigh Dathanna", X = "Léim go céatadán sonrach (1-10%, 2-20%, srl)", v = "Léim go dtí an Tús", y = "Gníomhartha le haghaidh {{title}}", j = "Aicearraí Méarchláir", k = "Teanga", w = "Saighead Chlé", nn = "Príomhroghchlár", an = "{{count}} nóiméad", tn = "{{count}} nóiméad", sn = "Balbhaigh", on = "Balbhaithe", cn = "Teanga don Chéad Fhotheideal Eile", hn = "An chéad toradh cuardaigh eile", An = "Múchta", Tn = "Ar Bharr", En = "Oscail anótáil ag {{time}}", Sn = "Oscail an quiz críochnaithe ag {{time}}", en = "Oscail an quiz ag {{time}}", rn = "Cuir ar Sos", _n = "Seinn", Nn = "Luas Athsheanma", Rn = "Luas Athsheanma: {{speed}}x", On = "Teanga na bhFotheideal Roimhe Seo", Cn = "Toradh cuardaigh roimhe seo", In = "Caighdeán", dn = "Roghchlár Cáilíochta", un = "Athimirt", gn = "Athshocraigh Luas Athsheanma", ln = "Saighead ar Dheis", Ln = "Cuardaigh sa tras-scríbhinn", Pn = "{{count}} s(h)oicind", Un = "{{count}} s(h)oicind", Dn = "Cuardaigh siar: {{seconds}} soicind", mn = "Cuardaigh ar aghaidh: {{seconds}} soicind", Mn = "Socruithe", bn = "Aicearra", Gn = "Sonraí agus uirlisí meán", Yn = "Spás", Fn = "Roghchlár luas athsheinm", Bn = "Tosaigh Uath-scrolláil", Hn = "Scoránaigh Fotheidil", Vn = "Scoránaigh Balbhaithe", Kn = "Scoránaigh Cuir ar siúl/Cuir ar sos", fn = "is {{count}} líne trascríbhinne é", Wn = "is {{count}} línte trascríbhinne é", $n = "Ag lódáil tras-scríbhinn...", pn = "Ní raibh muid in ann an trascríbhinn a lódáil.", Qn = "Roghanna Tras-scríbhinne", Jn = "Bain triail eile as", qn = "Tras-scríbhinn ar fáil", xn = "Saighead Suas", Zn = "Socruithe Físeáin", zn = "Toirt", Xn = "Toirt: {{volume}}%", vn = {
  A11Y_DURATION: n,
  A11Y_SEARCH_HITS: a,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: i,
  A11Y_TIMESTAMP_JUMP_MINUTES: c,
  A11Y_TIMESTAMP_JUMP_SECONDS: h,
  A11Y_TRANSCRIPT_ERROR: A,
  A11Y_TRANSCRIPT_LINE: T,
  A11Y_TRANSCRIPT_LINES: E,
  A11Y_TRANSCRIPT_SAVING: S,
  A11Y_TRANSCRIPT_SUCCESS: e,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: r,
  ACTION: _,
  ADD_ANNOTATION_AT: N,
  ADD_QUESTION_AT: R,
  ANNOTATIONS: O,
  AUTO: C,
  AUTO_QUALITY: I,
  BACK: d,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: g,
  CAPTIONS_MANAGE: l,
  CAPTION_DELETE: L,
  CAPTION_FONT_SIZE: P,
  CAPTION_LANGUAGE: U,
  CAPTION_LANGUAGE_AUTOMATIC: D,
  CLEAR_SEARCH: m,
  CLOSE: M,
  COMMENTS: b,
  CONTINUE: G,
  DECREASE_PLAYBACK_SPEED: Y,
  DECREASE_VOLUME: F,
  DOWN_ARROW: B,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: V,
  EDIT_ERROR: K,
  EDIT_SAVING: f,
  EDIT_SUCCESS: W,
  EDIT_TRANSCRIPT: $,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: Q,
  HOURS: J,
  HOURS_other: q,
  INCREASE_PLAYBACK_SPEED: x,
  INCREASE_VOLUME: Z,
  INVERT_COLORS: z,
  JUMP_TO_PERCENTAGE: X,
  JUMP_TO_START: v,
  KEBAB_MENU: y,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: nn,
  MINUTES: an,
  MINUTES_other: tn,
  MUTE: sn,
  MUTED: on,
  NEXT_CAPTION_LANGUAGE: cn,
  NEXT_HIT: hn,
  OFF: An,
  ON_TOP: Tn,
  OPEN_ANNOTATION_AT: En,
  OPEN_COMPLETED_QUIZ_AT: Sn,
  OPEN_QUIZ_AT: en,
  PAUSE: rn,
  PLAY: _n,
  PLAYBACK_SPEED: Nn,
  PLAYBACK_SPEED_MESSAGE: Rn,
  PREVIOUS_CAPTION_LANGUAGE: On,
  PREVIOUS_HIT: Cn,
  QUALITY: In,
  QUALITY_MENU: dn,
  REPLAY: un,
  RESET_PLAYBACK_SPEED: gn,
  RIGHT_ARROW: ln,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Ln,
  SECONDS: Pn,
  SECONDS_other: Un,
  SEEK_BACKWARD: Dn,
  SEEK_FORWARD: mn,
  SETTINGS: Mn,
  SHORTCUT: bn,
  SIDEBAR: Gn,
  SPACE: Yn,
  SPEED_MENU: Fn,
  START_AUTOSCROLL: Bn,
  TOGGLE_CAPTIONS: Hn,
  TOGGLE_MUTED: Vn,
  TOGGLE_PLAY_PAUSE: Kn,
  TRANSCRIPT_LINES: fn,
  TRANSCRIPT_LINES_other: Wn,
  TRANSCRIPT_LOADING: $n,
  TRANSCRIPT_LOAD_ERROR: pn,
  TRANSCRIPT_OPTIONS: Qn,
  TRANSCRIPT_RETRY: Jn,
  TRANSCRIPT_UNAVAILABLE: qn,
  UP_ARROW: xn,
  VIDEO_SETTINGS: Zn,
  VOLUME: zn,
  VOLUME_VALUE: Xn
};
export {
  n as A11Y_DURATION,
  a as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  i as A11Y_TIMESTAMP_JUMP_HOURS,
  c as A11Y_TIMESTAMP_JUMP_MINUTES,
  h as A11Y_TIMESTAMP_JUMP_SECONDS,
  A as A11Y_TRANSCRIPT_ERROR,
  T as A11Y_TRANSCRIPT_LINE,
  E as A11Y_TRANSCRIPT_LINES,
  S as A11Y_TRANSCRIPT_SAVING,
  e as A11Y_TRANSCRIPT_SUCCESS,
  r as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  _ as ACTION,
  N as ADD_ANNOTATION_AT,
  R as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  C as AUTO,
  I as AUTO_QUALITY,
  d as BACK,
  u as CAPTIONS,
  g as CAPTIONS_LANGUAGE,
  l as CAPTIONS_MANAGE,
  L as CAPTION_DELETE,
  P as CAPTION_FONT_SIZE,
  U as CAPTION_LANGUAGE,
  D as CAPTION_LANGUAGE_AUTOMATIC,
  m as CLEAR_SEARCH,
  M as CLOSE,
  b as COMMENTS,
  G as CONTINUE,
  Y as DECREASE_PLAYBACK_SPEED,
  F as DECREASE_VOLUME,
  B as DOWN_ARROW,
  H as EDIT_CLOSE,
  V as EDIT_CONFIRM,
  K as EDIT_ERROR,
  f as EDIT_SAVING,
  W as EDIT_SUCCESS,
  $ as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  Q as FULLSCREEN,
  J as HOURS,
  q as HOURS_other,
  x as INCREASE_PLAYBACK_SPEED,
  Z as INCREASE_VOLUME,
  z as INVERT_COLORS,
  X as JUMP_TO_PERCENTAGE,
  v as JUMP_TO_START,
  y as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  nn as MAIN_MENU,
  an as MINUTES,
  tn as MINUTES_other,
  sn as MUTE,
  on as MUTED,
  cn as NEXT_CAPTION_LANGUAGE,
  hn as NEXT_HIT,
  An as OFF,
  Tn as ON_TOP,
  En as OPEN_ANNOTATION_AT,
  Sn as OPEN_COMPLETED_QUIZ_AT,
  en as OPEN_QUIZ_AT,
  rn as PAUSE,
  _n as PLAY,
  Nn as PLAYBACK_SPEED,
  Rn as PLAYBACK_SPEED_MESSAGE,
  On as PREVIOUS_CAPTION_LANGUAGE,
  Cn as PREVIOUS_HIT,
  In as QUALITY,
  dn as QUALITY_MENU,
  un as REPLAY,
  gn as RESET_PLAYBACK_SPEED,
  ln as RIGHT_ARROW,
  Ln as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Pn as SECONDS,
  Un as SECONDS_other,
  Dn as SEEK_BACKWARD,
  mn as SEEK_FORWARD,
  Mn as SETTINGS,
  bn as SHORTCUT,
  Gn as SIDEBAR,
  Yn as SPACE,
  Fn as SPEED_MENU,
  Bn as START_AUTOSCROLL,
  Hn as TOGGLE_CAPTIONS,
  Vn as TOGGLE_MUTED,
  Kn as TOGGLE_PLAY_PAUSE,
  fn as TRANSCRIPT_LINES,
  Wn as TRANSCRIPT_LINES_other,
  $n as TRANSCRIPT_LOADING,
  pn as TRANSCRIPT_LOAD_ERROR,
  Qn as TRANSCRIPT_OPTIONS,
  Jn as TRANSCRIPT_RETRY,
  qn as TRANSCRIPT_UNAVAILABLE,
  xn as UP_ARROW,
  Zn as VIDEO_SETTINGS,
  zn as VOLUME,
  Xn as VOLUME_VALUE,
  vn as default
};
